<template>
  <div class="modal" :style="{ zIndex: modalZIndex }">
    <main>
      <slot></slot>
    </main>
  </div>
</template>

<script>
export default {
  name: 'ModalView',
  props: [
    'modalZIndex',
  ],
  data: function () {
    return {
    }
  },
}
</script>


<style scoped>
.modal {
  background-color: #fff;
  bottom: 0;
  box-shadow: 0 0 24px 0 rgba(0,0,0,0.12);
  left: 0;
  /*margin-bottom: -100px;
  padding-bottom: 100px;*/
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  padding-top: env(safe-area-inset-top);
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1020;
}

/*.action_bar--icon--none .action_bar--button--primary {
}
.action_bar--icon--back .action_bar--button--primary {
  background: url('/img/icon--arrow--back.svg') no-repeat center center;
}
.action_bar--icon--close .action_bar--button--primary {
  background: url('/img/icon--delete.svg') no-repeat center center;
}*/

main {
  padding: 0;
}
</style>
